import { render, staticRenderFns } from "./AdminHomeStudentGrid.vue?vue&type=template&id=37d804b0"
import script from "./AdminHomeStudentGrid.vue?vue&type=script&lang=js"
export * from "./AdminHomeStudentGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports